import React from "react";
import "./ImpersonateUser.css";
import { MuiThemeProvider, createTheme } from '@material-ui/core/styles';
import FetchService from "../../common/FetchService";
import FormControl from '@material-ui/core/FormControl';
import InputLabel from '@material-ui/core/InputLabel';
import Select from '@material-ui/core/Select';
import MenuItem from '@material-ui/core/MenuItem';
import Button from '@material-ui/core/Button';
import config from '../../config';
import AuthService from '../../common/AuthService';
import { SnackAlert } from '../../common/SnackAlert';
import { STORAGE_KEYS }                  from '../../common/keys';

const theme = createTheme({
    overrides: { MuiTooltip: { tooltip: { fontSize: '0.9em' } } },
    palette: {
        primary: {
            main: '#509556',
        },
    },
    typography: {
        fontSize: 13,
    }
});

/**
 * Impersona un altro utente
 * @param {string} targetUserId - kUser dell'utente da impersonare
 * @returns {Promise<Object>} Dati utente impersonato in caso di successo
 */
async function impersonateUser( targetUserId ) {
        
        const oResponse = await FetchService.asyncPost({
             url:    '/impersonate'
            ,params: { kUserToImpersonate: targetUserId + '' }
        });
        
        if ( oResponse?.success ) {
            this.storeUserData( oResponse ); // in impersonateUser
            return oResponse;
        }
        
        throw new Error('Impersonation failed');
        
}

class ImpersonateUser extends React.Component {

    constructor(props) {
        super(props);

        this.state = {
            users: [],
            utenteCod: "",
            oNotifyOptions:{ message: '', severity: '' } // severity: 'error' | 'warning' | 'info' | 'success'
        };
    }
    
    async componentDidMount() {
        this.loadUsers();
    }

    async loadUsers(){
        let users = [];
        const usersFromDb = await FetchService.asyncGet({ url: "/lookup/user-list" });
        if ( !usersFromDb || !usersFromDb.length ) {
            return;
        }

        for(let i=0; i< usersFromDb.length; i++){
            const user = usersFromDb[i];
            if (
                user 
                && user.KUSER 
                && ( ( user.KUSER + '' ) !== ( this.state.kUser + '' ) )
                && ( user.FLAG_ATTIVO === 'Y' )
            ) {
                users.push(user);
            }
        }
        this.setState({users: users});
    }

    handleChange(event){
        this.setState({ [event.target.name] : event.target.value});
    }
    
    async handleSubmitImpersonate(event) {
        try {
            const oResponse = await FetchService.asyncPost({
                 url:    '/impersonate'
                ,params: { kUserToImpersonate: this.state.utenteCod + '' }
            });
            
            if ( !oResponse?.success ) {
                throw new Error('Impersonation failed');
                
            } else {
                this.props.userImpersonate(oResponse);
            }
            
        } catch (error) {
            this.toggleNotifica( error.message, 'error' );
        }
    }
    
    handleCloseAlert = (event, reason) => {
        // if (reason === 'clickaway') { return; }
        this.setState( { oNotifyOptions: { ...this.state.oNotifyOptions, message: '' } } );
    }

    toggleNotifica   = ( message, severity ) => {
        this.setState( { oNotifyOptions: { ...this.state.oNotifyOptions, message, severity } } );
    }

    render() {
        const {
            users,
            utenteCod,
        } = this.state;

        let optionUsers = users.map((user) =>
            <MenuItem key={user.KUSER} value={user.KUSER}>{user.FULL_NAME}</MenuItem>
        );

        return (
            <div className="impersonate-user">
                { /* ----- notifiche ----- */ }
                <SnackAlert oNotifyOptions={ { ...this.state.oNotifyOptions, handleCloseAlert: this.handleCloseAlert, source: 'ImpersonateUser' } } />
                
                <MuiThemeProvider theme={theme}>
                    <div className="row">
                        <FormControl>
                            <InputLabel htmlFor="utenteCod">User to impersonate</InputLabel>
                            <Select
                                value={utenteCod}
                                style={{minWidth:250}}
                                onChange={this.handleChange.bind(this)}
                                inputProps={{
                                    name: 'utenteCod',
                                    id: 'utenteCod',
                                }}
                            >
                                {optionUsers}
                            </Select>
                        </FormControl>
                    </div>

                    <div className="submit-buttons">
                        <span className="button">
                            <Button variant="contained"
                                    color="primary"
                                    onClick={(event) => this.handleSubmitImpersonate(event)}
                                    disabled={utenteCod===''}
                            >Impersonate</Button>
                        </span>
                    </div>

                </MuiThemeProvider>
            </div>
        );
    }
}

export default ImpersonateUser;
